/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Authentication
 */
export interface Authentication {
  /**
   *
   * @type {string}
   * @memberof Authentication
   */
  address?: string
}

export function AuthenticationFromJSON(json: any): Authentication {
  return AuthenticationFromJSONTyped(json, false)
}

export function AuthenticationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Authentication {
  if (json === undefined || json === null) {
    return json
  }
  return {
    address: !exists(json, 'address') ? undefined : json['address'],
  }
}

export function AuthenticationToJSON(value?: Authentication | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    address: value.address,
  }
}
